<template>
    <div class="wrapper">
        <h1 class="title">
            <span>Identity Verification</span>                        
            <p class="guide">
                Step <em>{{ props.step }}</em> / {{ props.allstep }}
            </p>
        </h1>
        <Upload 
            :needShowList='obj["ada_front"]'
            title= "Aadhaar Front"
            :requestId="requestId"
            invoke_type = '1'
            type_txt = 'ada_front'
            @set_value=set_value
            fromPage="kyc_page"
            name="front"        
            @refreshRequestId = "refreshRequestId"
        ></Upload>      
        <Upload 
            :needShowList='obj["pan"]'
            title= "PAN"
            :requestId="requestId"
            invoke_type = '3'
            type_txt = 'pan'
            @set_value=set_value
            fromPage="kyc_page"
            name="pan" 
            @refreshRequestId = "refreshRequestId"
        ></Upload>  
        <Upload 
            :needShowList='obj["face"]'
            title= "Face Recognition"
            invoke_type = '5'
            type_txt = 'face'
            @set_value=set_value
            fromPage="kyc_page"
            name="face" 
            @refreshRequestId = "refreshRequestId"
        ></Upload>              
        <!-- <a href="javascript:void(0);" class="changetouploda-text" @click="changeVerify">Verify though Offline e-kyc  </a>                        -->
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' @click="submit">CONFIRM TO NEXT</a>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#189A63;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .placeholder{
        height: 176px;        
    }
    .hih-caption{
        color:#A59BB3;
        font-size:28px;
        margin-bottom: 30px;
        line-height: 1.5;
    }
    .wrapper{
        padding:40px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:#189A63;
            font-size: 40px;
            margin: 0 0 50px 0;  
            .guide{
                color:#A59BB3;
                font-size: 30px;
                em{
                    color:#189A63;
                    font-weight: 700;
                }
            }
        }
    }
    .changetouploda-text{
    display: block;
    text-align: center;
    text-decoration: underline;
    font-size: 28px;
    color:#7455BF;
    margin-top: 40px;
}
</style>
<script>
import Upload from '@/components/business/kyc/upload.vue'
import { onMounted, reactive, getCurrentInstance,ref,onBeforeMount,onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { key_submit } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
import { getActiveResult, faceConfig } from '@api/index';
import { v4 as uuidv4} from 'uuid'
import { useStore } from 'vuex'
export default {
    components:{
        Upload
    },
    props:{
        step:String,
        allstep:String
    },
    setup(props, ctx) {
        const $loading = useLoading()
        const clicked = ref(false)
        const router = useRouter()
        const route = router.currentRoute
        const proxy = getCurrentInstance().proxy
        
        const obj = reactive({
            "ada_front": {
                "file_name":"",
                "needToShow":[]
            },
            "ada_back": {
                "file_name":"",
                "needToShow":[]

            },
            "pan": {
                "file_name":"",
                "needToShow":[]
            },            
            "face": {
                "file_name":"",
                "needToShow":[]
            },            
        })  
        let requestId = ref(uuidv4())
        const store = useStore()
        const config = reactive({
            living_type:null
        })  
        const changeVerify = () => {
            ctx.emit("changeState", 0)
        }    
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"kyc_page_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"kyc_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })

        onMounted(async () => {
            document.body.style.background = '#F8F8F8'
            const data = await faceConfig()            
            config.living_type = data.data['living-config']
            if (config.living_type == 1) {
                getActiveResult()
            }
            
        })
        const validate = () => {
            let res = true
            if(obj['ada_front']['file_name']== '') {
                proxy.$toast.show('Please Upload Aadhaar front')
                res =false
            } 
            // else if (obj['ada_back']['file_name'] == '') {
            //     proxy.$toast.show('Please Upload Aadhaar Back ')
            //     res =false
                
            // } 
            else if ( obj['pan']['file_name'] == '' ){
                proxy.$toast.show('Please Upload PAN ')
                res =false
            }
            else if ( obj['face']['file_name'] == '' ){
                proxy.$toast.show('Please Upload Face ')
                res =false
            } 
            
            return res
        }
        const submit = async () => {
            store.dispatch("bury",{"event_id":"kyc_info_enter_button_click"})
            if(!validate()) return
            if(clicked.value)return 
            clicked.value = true
            const loader = $loading.show({
                container: null
            })
            let data = await key_submit({
                type:1                
            })
            loader.hide()
            clicked.value = false
            if(data.code == 0) {
                store.dispatch("bury",{"event_id":"kyc_info_enter_button_click_success"})
                store.dispatch("uploadBury")                         
                router.push({
                    "path":"/auth/index",
                    "query":{
                        "pid":route.value.query.pid
                    }
                })                         
            } else {
                proxy.$toast.show(data.msg)
            }
        }

        const set_value = (key, v) => {
            obj[key] = v
        }
        const refreshRequestId = () => {
            requestId.value = uuidv4()
        }
        const setCount = (ind, count) => {
            obj.select_types[ind].eventCount = count
        }

        return {
            refreshRequestId,
            setCount,
            obj,
            set_value,
            submit,
            validate,
            config,
            requestId,
            props,
            changeVerify
        }
        
    }
}
</script>